import {isEmpty} from 'lodash'
import {loader, logout, errorHandler, message} from '@/libs/helper'
import constants from '@/libs/constant/constants'
import {generateToken} from '@/libs/api/api'
import pageRoutes from '../../../../libs/constant/pageRoutes'

export default{
    props:{
            userInformation: {
                type: Object,
                default: () => {}
            },
            module: {
                type: String,
                default: constants.ADMIN.Users.value_without_s
            },
            selectedAccount: {
                type: Object,
                default: () => {}
            }

    },
    computed:{
        activeProfile() {
            return this.selectedAccount.id || this.selectedAccount._id
        }
    },

    emits:['error','routeToMyAccount','switchProfile'],

    methods:{
        /*
        * returns the user to fetch the user's avatar.
        * */
        getURL(){
            if (this.userInformation && this.userInformation.avatar_image) {
                return `${process.env.VUE_APP_API_BASE_URL}/accounts/files/${this.userInformation.avatar_image}?auth=${localStorage.getItem('accuraAuthToken')}`
            } else {
                let avatarURL = require('@/assets/images/img_avatar.png')
                return avatarURL
            }
        },

        /*
        * return the place holder image in case of error in image loading.
        * */
        onError(e) {
            this.$emit('error',e)
        },

        /**
         * route to my account
         */
        routeToMyAccount(){
            this.$emit('routeToMyAccount');
        },
        routeToOrgPage() {
            this.$router.push({name: pageRoutes.organisationOverview, params: {id: this.userInformation._id}})
        },
        /**
         * to switch to main profile and generate token if needed
         */
        switchProfile () {    
            // if user information is empty then return
            if (isEmpty(this.userInformation)) return
            // if switching to main profile
            const lastAccuraToken = localStorage.getItem('accuraAuthToken')
            const token = localStorage.getItem(`profile_${this.userInformation._id}`)
            if (this.module === constants.ADMIN.Users.value_without_s && this.userInformation.type === 'USER') {
                // loader(this, true)
                // set current selected account
                if ((token !== null && token !== undefined && token !== '')) {
                    // set accura token to the new one
                    localStorage.setItem('accuraAuthToken', token)
                    // set the active profile
                    localStorage.setItem('activeProfile', this.userInformation._id)
                    this.$store.dispatch('setRefreshUserProfileAndPermissions', true)
                    this.$router.push({name: pageRoutes.usersOverview, params: {id: this.userInformation._id}})
                } else {
                    logout(this)
                }
                // loader(this, false)
            }
            // if switching to organisation profile 
            else if (this.module === constants.ADMIN.Organisations.value_without_s && this.userInformation.type === 'ORGANISATION') {

                // if token is already present
                if (token !== null && token !== undefined && token !== '') {
                    localStorage.setItem('accuraAuthToken', token)
                    localStorage.setItem('activeProfile', this.userInformation._id)
                    if (this.activeProfile && lastAccuraToken) localStorage.setItem(`profile_${this.activeProfile}`, lastAccuraToken)

                    this.$store.dispatch('setRefreshUserProfileAndPermissions', true)
                    this.$router.push({name: pageRoutes.organisationOverview, params: {id: this.userInformation._id}})
                }
                // else generate token
                else {
                    loader(this, true)
                    generateToken({organisation: this.userInformation._id, user_id: this.$store.getters.getUserInformation.id})
                    .then(() => {
                        loader(this, false)
                        localStorage.setItem(`profile_${this.userInformation._id}`, localStorage.getItem('accuraAuthToken'))
                        localStorage.setItem('activeProfile', this.userInformation._id)
                        if (this.activeProfile && lastAccuraToken) localStorage.setItem(`profile_${this.activeProfile}`, lastAccuraToken)

                        this.$store.dispatch('setRefreshUserProfileAndPermissions', true)
                        this.$router.push({name: pageRoutes.organisationOverview, params: {id: this.userInformation._id}})
                    })
                    .catch(error => {
                        loader(this, false)
                        console.error(error)
                        message(this, constants.messageType.ERROR, errorHandler(error, logout.bind(this, this)))
                    });
                }
            }
        } 
    }
}